module.exports = __webpack_public_path__ + "img/icons BFr_36.7fc09c74.png";